// extracted by mini-css-extract-plugin
export default {"profileCont":"Profilepopup_profileCont__xAwi8","profile":"Profilepopup_profile__07tUh","images":"Profilepopup_images__DPfwW"};